import { Auxiliars } from "helpers";
import { IUser } from "./user";

export interface IConfiguration {
  _id: string;
  name: string;
  bgColor: string;
  textColor: string;
};

export interface IMenu {
  count: number;
  configuration: IConfiguration;
  categories: ICategory[];
  // not part of the schema
  readonly: boolean;
  new: boolean;
};

export interface ICategoryResponse {
  user: IUser;
  vote: boolean;
}

export interface ICategory {
  _id: string;
  name: string;
  assigned_to: IUser[];
  suggested_by: IUser;
  replaced_with: string;
  responses: ICategoryResponse[];
  cancelled: boolean;
  // not part of the schema
  readonly: boolean;
  new: boolean;
}

export const createDefaultCategory = (): ICategory => ({
  _id: Auxiliars.generateObjectId(),
  name: "",
  assigned_to: [],
  responses: [],
  new: true,
  readonly: false,
  replaced_with: "",
  cancelled: false,
  suggested_by: {} as IUser,
});

export const createDefaultMenu = (withDefault: boolean): IMenu => ({
  configuration: {} as IConfiguration,
  count: 1,
  new: true,
  readonly: false,
  categories: withDefault ? [{ ...createDefaultCategory() }] : [],
});